import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledGridContainerSubtitle = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  fontWeight: 'bold',
  fontSize: '1.125rem',
  letterSpacing: '-0.5px',
  lineHeight: '1.5rem',
  fontFamily: theme.typography.mainFont,
}));

export { StyledGridContainerSubtitle };
